import React, { useState } from 'react'
import HdRequestData from './HdRequestData';
import Popup from './Popup';
import ImagesPopup from './ImagesPopup';

export default function HDrequestpopup(props) {
    var PopupData = props.PopupData;
    const [showImagesModal, setShowImagesModal] = useState({
        show: false,
        activeIndex: 0,
        zoomInOut: false,
        imageUrl: null
    });

    function handleShowImageModal(url) {
        setShowImagesModal({ ...showImagesModal, show: true, imageUrl: url, activeIndex: 0, zoomInOut: false })
    }

    return (
        <React.Fragment>
            <Popup
                isshow={props.isShow}
                size={"md"}
                title={"Help Desk Request Details"}
                closePopup={(e) => props.closepopup()}
                modalBody={
                    <HdRequestData
                        data={PopupData}
                        handleShowImageModal={handleShowImageModal}
                    />
                }
                visibleSaveBtn={false}
                isBlur={showImagesModal.show}
            />
            {showImagesModal.show &&
                <ImagesPopup
                    AllImages={[showImagesModal.imageUrl]}
                    isShow={showImagesModal.show}
                    closePopup={() => setShowImagesModal({ ...showImagesModal, show: false, activeIndex: 0, zoomInOut: false, imageUrl: null })}
                    title={"Preview Images"}
                    size={"xl"}
                    activeIndex={showImagesModal.activeIndex}
                    handleActiveIndex={(selectedIndex) => setShowImagesModal((prev) => ({ ...prev, activeIndex: selectedIndex, zoomInOut: false }))}
                    zoomInOut={showImagesModal.zoomInOut}
                    handleZoomInOut={() => setShowImagesModal({ ...showImagesModal, zoomInOut: !showImagesModal.zoomInOut })}
                />
            }

        </React.Fragment>
    )
}
